export const AppRoute = {
  SPLASH: "/",
  LOGIN: "/login",
  FORGOTPASS: "/forgot-password",

  JOBSEEKER_REGISTER: "/jobs/jobs-register",
  EMPLOYEE_REGISTER: "/emp/register",
EMPLOYEE_REGISTER_STEP2: "/emp/add-password",
  EMPLOYEE_REGISTER_STEP3: "/emp/verify-account",
  EMPLOYEE_REGISTER_STEP4: "/emp/company-registration",
  AGENT_REGISTER: "/agent/register",
  AGENT_REGISTER_STEP2: "/agent/add-password",
  AGENT_REGISTER_STEP3: "/agent/verify-account",
  AGENT_REGISTER_STEP4: "/agent/agency-registration",
  VERIFY_FORGET_PASS: "/agent/email-verification",
  RESET_PASSWORD: "/reset-password",
  JOBSEEKER_DASHBOARD: '/jobseeker/dashboard',
  JOBSEEKER_JOBS_LISTING:'/jobseeker/jobs-listing',
  JOBSEEKER_JOBS_DETAILS:'/jobseeker/jobs-details',
  JOBSEEKER_APPLIED_JOBS:'/jobseeker/applied-job',
  JOBSEEKER_REQUEST_IMMIGRATION:'/jobseeker/request-immigration-form',
  JOBSEEKER_SETTINGS:'/jobseeker/settings',
  JOBSEEKER_MY_ACCOUNT:'/jobseeker/resume-account-details',  
  JOBSEEKER_MY_RESUME:'/jobseeker/my-resume',
  JOBSEEKER_WORK_EXPERIENCE:'/jobseeker/resume-experience',
  JOBSEEKER_ADDED_WORK_EXPERIENCE:'/jobseeker/resume-added-work-experience',
  JOBSEEKER_EDUCATION:'/jobseeker/resume-education-information',
  JOBSEEKER_AFTER_ADDED_EDUCATION:'/jobseeker/resume-after-added-education-information',
  JOBSEEKER_ACHIEVEMENTS:'/jobseeker/resume-achievements-information',
  JOBSEEKER_AFTER_ADDED_ACHIEVEMENTS:'/jobseeker/resume-after-added-achievements-information',
  JOBSEEKER_QUALIFICATIONS:'/jobseeker/resume-qualification-information',
  JOBSEEKER_AFTER_ADDED_QUALIFICATIONS: '/jobseeker/resume-after-added-qualification-information',
  JOBSEEKER_NOTIFICATIONS:'/jobseeker/notifications',
  JOBSEEKER_MESSAGE: '/jobseeker/message',

  AGENT_DASHBOARD: '/agent-flow/dashboard',
  AGENT_UPLOAD_RESUME: '/agent-flow/my-resume',
  AGENT_MANAGE_JOBS: '/agent-flow/manage-jobs',
  AGENT_SETTINGS: '/agent-flow/settings',
  AGENT_MY_ACCOUNT:'/agent-flow/account-details',
  AGENT_JOBS_LISTING:'/agent-flow/jobs-listing',
  AGENT_JOBS_DETAILS:'/agent-flow/jobs-details',
  AGENT_APPLIED_JOBS:'/agent-flow/applied-job',
  AGENT_APPLICATIONS:'/agent-flow/applications',

  AGENT_MY_RESUME:'/agent-flow/my-resume',
  AGENT_WORK_EXPERIENCE:'/agent-flow/resume-experience',
  AGENT_ADDED_WORK_EXPERIENCE:'/agent-flow/resume-added-work-experience',
  AGENT_EDUCATION:'/agent-flow/resume-education-information',
  AGENT_AFTER_ADDED_EDUCATION:'/agent-flow/resume-after-added-education-information',
  AGENT_ACHIEVEMENTS:'/agent-flow/resume-achievements-information',
  AGENT_AFTER_ADDED_ACHIEVEMENTS:'/agent-flow/resume-after-added-achievements-information',
  AGENT_QUALIFICATIONS:'/agent-flow/resume-qualification-information',
  AGENT_AFTER_ADDED_QUALIFICATIONS: '/agent-flow/resume-after-added-qualification-information',
  AGENT_NOTIFICATIONS:'/agent-flow/notifications',
  AGENT_MESSAGE : '/agent-flow/message',

  EMPLOYER_DASHBOARD: '/employer/dashboard',
  EMPLOYER_POST_JOB: '/employer/post-a-job',
  EMPLOYER_MANAGE_JOBS: '/employer/manage-jobs',
  EMPLOYER_SETTINGS: '/employer/settings',
  EMPLOYER_MY_ACCOUNT: '/employer/account-details',
  EMPLOYER_EDIT_JOB: '/employer/edit-job',
  EMPLOYER_APPLICANTS: '/employer/applicants',
  EMPLOYER_NOTIFICATIONS:'/employer/notifications',
  EMPLOYER_MESSAGE: '/employer/message',
  JOBS_LISTING: '/job-listing',
  JOBS_Details: '/job-details/'
};
